import { useNavigate } from "react-router";
import { useCookies } from "react-cookie";
import Business from "../models/Business.tsx";
import Authorization from "../models/Authorization.tsx";
import { useAuth } from "../components/AuthProvider.tsx";

const AdministratorRoute = ({children}) => {  
  const navigate = useNavigate();
  const [cookies] = useCookies(["Token"]);
  const { authorization, SetAuthorization } = useAuth();

  if (!authorization)
  {
    var token = cookies["Token"];
    if (token) {
      fetch("/api/business?token=" + token)
        .then(response => response.json())
        .then(data => {
          const business: Business = data;
          var isComplete = business.OperatingName &&
            business.LegalName &&
            business.Address &&
            business.City &&
            business.PostalCode &&
            business.OperatingSectorId &&
            business.BusinessSizeId &&
            business.YearsOfOperationId &&
            business.FirstName &&
            business.LastName &&            
            business.Telephone &&
            business.Email &&
            business.IsTermsAndConditions;

          const authorization: Authorization = {
            Token: token,
            DesignationNumber: business.DesignationNumber,
            IsAdministrator: business.IsAdministrator,
            IsComplete: isComplete
          };
          SetAuthorization(authorization);
        })
        .catch(error => SetAuthorization(null));
    }
  }
  
  if (!authorization) {
    return navigate("/admin");
  } 

  if (!authorization.IsAdministrator) {
    return navigate("/admin");
  }   

  return children;
}

export default AdministratorRoute;